import type { VehicleType } from '@raahi/shared';

interface Props {
  type: VehicleType;
  size?: number;
}

/** Simple inline SVGs — avoids ferrying raster icons through the bundle. */
export function VehicleIllustration({ type, size = 32 }: Props) {
  if (type === 'bike') {
    return (
      <svg width={size} height={size * 0.66} viewBox="0 0 48 32" fill="none" aria-hidden="true">
        <circle cx="10" cy="22" r="6" stroke="#22C55E" strokeWidth="2.5" />
        <circle cx="38" cy="22" r="6" stroke="#22C55E" strokeWidth="2.5" />
        <path d="M10 22l8-12h12l4 12" stroke="#E5E9F0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M30 10l4-4" stroke="#E5E9F0" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="22" cy="13" r="1.5" fill="#22C55E" />
      </svg>
    );
  }
  const tone = type === 'premium' ? '#F59E0B' : '#E5E9F0';
  return (
    <svg width={size} height={size * 0.55} viewBox="0 0 48 26" fill="none" aria-hidden="true">
      <path
        d="M4 18v-4l4-1 4-7h24l4 7 4 1v4l-2 2h-3a4 4 0 01-8 0H17a4 4 0 01-8 0H6l-2-2z"
        fill={tone}
        opacity="0.95"
      />
      <path d="M12 11l3-5h18l3 5" stroke="#0B0F14" strokeWidth="1.2" />
      <circle cx="13" cy="20" r="3" fill="#0B0F14" />
      <circle cx="35" cy="20" r="3" fill="#0B0F14" />
      <circle cx="13" cy="20" r="1" fill={tone} />
      <circle cx="35" cy="20" r="1" fill={tone} />
    </svg>
  );
}
